module.exports = __webpack_public_path__ + "assets/img/icon-3.11746b3c.png";